module.exports = __webpack_public_path__ + "img/vitamina-C.8e9c07b0.png";